export default "__VITE_ASSET__hbq18ayw__"